import CryptoJS from 'crypto-js';
import { Base64_decode } from './api';

const _base64ToArrayBuffer = function (base64) {
  const binary_string = window.atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
};

const _arrayBufferToBase64 = function (buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const decryptRequest = function (k, data, salt) {
  // 接口返回的值拼上盐
  const keyStr = Base64_decode(k).trim() + ':' + salt;
  // 生成秘钥
  let key = CryptoJS.MD5(keyStr).toString().toUpperCase();
  key = CryptoJS.enc.Utf8.parse(key);

  // 解析数据
  const buffer = _base64ToArrayBuffer(data);
  const arr = Array.from(new Int8Array(buffer));
  const arrIv = arr.slice(0, 16);
  const arrData = arr.slice(16);

  // 生成iv 和
  let iv = _arrayBufferToBase64(arrIv);
  iv = CryptoJS.enc.Base64.parse(iv);

  // 生成密文
  const str = _arrayBufferToBase64(arrData);

  const decrypt = CryptoJS.AES.decrypt(str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypt.toString(CryptoJS.enc.Utf8);
};
